import { Resource as i, API as r } from "@coveo/platform-client";
const t = class t extends i {
  /**
   * Retrieves quota information for a specific entitlement key within the organization. Returns detailed quota status including current usage for the specified entitlement.
   */
  async get(s) {
    return this.api.get(
      this.buildPath(`${t.baseUrl}/${s}`)
    );
  }
};
t.baseUrl = `/api/private/organizations/${r.orgPlaceholder}/quotas/entitlements`;
let e = t;
export {
  e as OrganizationQuotasResource
};
//# sourceMappingURL=OrganizationQuotasResource.js.map
